import _Spin from "@arco-design/web-react/es/Spin";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import React from 'react';
import { Switch, Redirect, Route } from 'react-router';
import lazyload from '@src/utils/lazyload';
import Nav from './common/nav';
import { enable } from '@src/common/enableFeature';
import useAppContext from '@src/hooks/useAppContext';
import { GlobalContext } from '../context';
import DesignLabSvg from '@src/assets/svg/design-lab.svg';
var Footer = lazyload(function () {
  return import('@arco-materials/site-footer');
});
var SiteHome = lazyload(function () {
  return import('./home');
});
var NotFound = lazyload(function () {
  return import('./notFound');
});
var ErrorFallback = lazyload(function () {
  return import('../pages/common/error');
});
var Store = lazyload(function () {
  return import('./home/store');
});
var StoreManage = lazyload(function () {
  return import('./manage');
});
var Dashboard = lazyload(function () {
  return import('./dashboard');
});
var Feedback = lazyload(function () {
  return import('../common/feedback');
});
var NoticeDashboard = lazyload(function () {
  return import('../pages/notice');
});
export default function Page() {
  var _a = useAppContext(),
    arcoLocale = _a.arcoLocale,
    contextValue = _a.contextValue;
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: arcoLocale,
    loadingElement: /*#__PURE__*/React.createElement(_Spin, {
      size: 30
    })
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("header", {
    style: {
      height: 61,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Nav, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/stores/manage",
    component: StoreManage
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/404",
    component: NotFound
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/error",
    component: ErrorFallback
  }), enable && /*#__PURE__*/React.createElement(Route, {
    path: "/dashboard",
    component: Dashboard
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/home",
    component: SiteHome
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/notice",
    component: NoticeDashboard
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: Store
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })))), /*#__PURE__*/React.createElement(Footer, {
    logo: /*#__PURE__*/React.createElement(DesignLabSvg, {
      width: "157",
      height: "36"
    }),
    lang: contextValue.lang
  }), /*#__PURE__*/React.createElement(Feedback, null)));
}